import * as d3 from 'd3';

interface DataPoint {
  [key: string]: string | number;
  bar: number;
  label: string;
  value: number;
}

type Arguments = {
  graph: d3.Selection<null, unknown, null, undefined>;
  data: Record<string, string | number>[];
  bars: string[];
  colors: d3.ScaleOrdinal<string, unknown, never>;
  monocolor: string | undefined | null;
  linearScale: d3.ScaleLinear<number, number, never>;
  bandScale: d3.ScaleBand<string | number>;
  graphId: string;
  setCoords?: (coords: [number, number] | null) => void;
  setTooltipData?: (data: DataPoint) => void;
  transform?: string;
  onHover?: (d?: DataPoint) => void;
};

export const appendBars = ({
  graph,
  data,
  bars,
  colors,
  monocolor,
  linearScale,
  bandScale,
  graphId,
  setCoords,
  setTooltipData,
  transform = 'translate(0, 0)',
  onHover,
}: Arguments) => {
  const onMouseOver = (
    event: MouseEvent,
    d: Record<string, string | number>,
  ) => {
    d3.selectAll(`.${graphId}-bar`).style('opacity', '0.4');
    d3.select(`.${graphId}-bar-${d.bar}`).style('opacity', '1');
    d3.select(`.${graphId}-text-${d.bar}`).style('font-weight', '600');
    const [x, y] = [
      (event.target as Element)?.getBoundingClientRect?.()?.right,
      (event.target as Element)?.getBoundingClientRect?.()?.top,
    ];

    if (x && y) {
      setCoords?.([x, y]);
      setTooltipData?.(d as DataPoint);
    }

    onHover?.(d as DataPoint);
  };
  const onMouseOut = () => {
    d3.selectAll(`.${graphId}-bar`).style('opacity', '1');
    d3.selectAll(`.${graphId}-text`).style('font-weight', '400');
    setCoords?.(null);
    onHover?.();
  };
  graph
    .append('g')
    .attr('transform', transform)
    .selectAll('g')
    .data(data)
    .enter()
    .append('rect')
    .attr('x', linearScale(0))
    .attr('y', (_, i) => Number(bandScale(String(bars[i]))))
    .attr('width', (d) => linearScale(Number(d.value)) - linearScale(0))
    .attr('height', bandScale.bandwidth())
    .attr('fill', (d) =>
      monocolor ? monocolor : String(colors(String(d.bar))),
    )
    .attr('class', (d) => `${graphId}-bar ${graphId}-bar-${d.bar}`)
    .on('mouseover', onMouseOver)
    .on('mouseout', onMouseOut);
};
